import React from 'react';

// A stylised V-Bucks coin (Fortnite's blue coin with white V).
export default function VBuck({ size = 18, className = '' }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="vbg" cx="35%" cy="30%" r="80%">
          <stop offset="0%" stopColor="#9be7ff" />
          <stop offset="55%" stopColor="#1ec3f5" />
          <stop offset="100%" stopColor="#0a5fa0" />
        </radialGradient>
      </defs>
      <circle cx="16" cy="16" r="14" fill="url(#vbg)" stroke="#0a3b66" strokeWidth="2" />
      <circle cx="16" cy="16" r="10.5" fill="none" stroke="#bff0ff" strokeWidth="1.2" opacity="0.85" />
      <path
        d="M9 9 L13 9 L16 18 L19 9 L23 9 L17.5 23 L14.5 23 Z"
        fill="#ffffff"
        stroke="#0a3b66"
        strokeWidth="0.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}
